// extracted by mini-css-extract-plugin
export default {"walletTracksComponent":"WalletTracks_walletTracksComponent__SnXbV"};